import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  counter: {
    display: 'block',
    textAlign: 'right',
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    width: '100%',
  },
}))

interface CharacterCounterProps {
  currentLength: number
  maxLength: number
}

export function CharacterCounter({
  currentLength,
  maxLength,
}: CharacterCounterProps) {
  const classes = useStyles()

  return (
    <div className={classes.counter}>
      {currentLength} / {maxLength}
    </div>
  )
}
